export default __webpack_public_path__ + "static/media/close.7abec4b0.svg";